export default __webpack_public_path__ + "static/media/help-with-my-orders.44548184.png";